import { FC } from 'react';
import { useTranslations } from '@altermaind/core/i18n';
import { Box, Card, Typography } from '@altermaind/web/ui';
import { useResponsiveStyle } from '@/_shared/hooks/useResponsiveStyle';
import { ResponsePostEmployerByIdSurveyResult } from '@/surveys/state/api';

type Props = {
  survey: ResponsePostEmployerByIdSurveyResult[0];
};

export const SurveyNotInvited: FC<Props> = ({ survey }) => {
  const t = useTranslations('department.details.assessment');

  const { genericResponsiveValue } = useResponsiveStyle();

  return (
    <>
      <Typography key={survey.templateId} variant='h3' mb='m'>
        {t('surveyTitle.notCompleted', {
          surveyTemplateName: survey.templateName,
        })}
      </Typography>
      <Card mb='m' p='l'>
        <Box display='flex' justifyContent='space-between' alignContent='center'>
          <Box
            alignItems={genericResponsiveValue({
              breakPoints: { desktop: 'center' },
              defaultValue: 'flex-start',
            })}
            display='flex'
            flexDirection={genericResponsiveValue({
              breakPoints: { desktop: 'row' },
              defaultValue: 'column',
            })}
          >
            <Typography variant='h2'>
              {t('title', {
                name: survey.templateName,
              })}
            </Typography>
            <Box
              display='flex'
              flexDirection={genericResponsiveValue({
                breakPoints: { desktop: 'row' },
                defaultValue: 'row',
              })}
              mt={genericResponsiveValue({
                breakPoints: { desktop: 'none' },
                defaultValue: 'xs',
              })}
            >
              <Box
                ml={genericResponsiveValue({
                  breakPoints: { desktop: 'xs' },
                  defaultValue: 'none',
                })}
                width='s'
                height='s'
                borderRadius='l'
                backgroundColor='error'
              />
              <Typography ml='xxxs' variant='p2/light'>
                {t('status.noSurvey')}
              </Typography>
            </Box>
          </Box>
        </Box>
        <Box mt='s' display='flex' flexDirection='row' alignItems='center'>
          <Box flex='1'>
            <Typography variant='p3/light'>{t('descriptionNotSent')}</Typography>
          </Box>
        </Box>
      </Card>
    </>
  );
};
